import { render, staticRenderFns } from "./statementItemCompare.vue?vue&type=template&id=31a11ab4"
import script from "./statementItemCompare.vue?vue&type=script&lang=js"
export * from "./statementItemCompare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31a11ab4')) {
      api.createRecord('31a11ab4', component.options)
    } else {
      api.reload('31a11ab4', component.options)
    }
    module.hot.accept("./statementItemCompare.vue?vue&type=template&id=31a11ab4", function () {
      api.rerender('31a11ab4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/smf/compare/statementItemCompare.vue"
export default component.exports